export default __webpack_public_path__ + "static/media/LGBTQIATeens.2675cef5.webp";